import { render } from "./ErrorMessage.vue?vue&type=template&id=6b833b2e&scoped=true"
import script from "./ErrorMessage.vue?vue&type=script&lang=js"
export * from "./ErrorMessage.vue?vue&type=script&lang=js"

import "./ErrorMessage.vue?vue&type=style&index=0&id=6b833b2e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b833b2e"]])

export default __exports__